'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('onyxReadingRoomApp.appconfs.edit', [])
  .controller('AppConfsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfs/edit/index.js